// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.res.mjs";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import Drop_downSvg from "./assets/drop_down.svg";
import CheckpointSvg from "./assets/checkpoint.svg";
import Icon_backingSvg from "./assets/icon_backing.svg";
import * as Theme$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Theme.res.mjs";
import Icon_backing_activeSvg from "./assets/icon_backing_active.svg";
import Icon_backing_lockedSvg from "./assets/icon_backing_locked.svg";
import * as CssUtils$LiteracyplanetClientSxEntry from "./CssUtils.res.mjs";
import * as DynamicLevelBar$LiteracyplanetClientSxEntry from "./DynamicLevelBar.res.mjs";
import * as StoryverseIcons$LiteracyplanetClientSxEntry from "./StoryverseIcons.res.mjs";
import * as StoryverseComponents$LiteracyplanetClientSxEntry from "./StoryverseComponents.res.mjs";

var brownColor = Css.rgba(85, 48, 19, {
      NAME: "num",
      VAL: 1.0
    });

var whiteColor = Css.rgba(255, 255, 255, {
      NAME: "num",
      VAL: 1.0
    });

var bottomBlueColor = Css.rgba(109, 207, 246, {
      NAME: "num",
      VAL: 1.0
    });

var topBlueColor = Css.rgba(141, 223, 255, {
      NAME: "num",
      VAL: 1.0
    });

var blueColor = Css.rgba(11, 185, 254, {
      NAME: "num",
      VAL: 1.0
    });

var offWhiteColor = Css.rgba(233, 220, 193, {
      NAME: "num",
      VAL: 1.0
    });

var lightOffWhiteColor = Css.rgba(253, 250, 240, {
      NAME: "num",
      VAL: 1.0
    });

var checkpoint = CheckpointSvg;

var dropDown = Drop_downSvg;

var iconBacking = Icon_backingSvg;

var iconBackingActive = Icon_backing_activeSvg;

var iconBackingLocked = Icon_backing_lockedSvg;

var r = Theme$LiteracyplanetClientFlags.resize(/* [] */0);

var css = Curry._1(Css.style, /* [] */0);

var className = Curry._1(Css.merge, {
      hd: css,
      tl: {
        hd: r,
        tl: {
          hd: "DynamicLevelBarStyle",
          tl: /* [] */0
        }
      }
    });

var DynamicLevelBarStyle = {
  r: r,
  css: css,
  className: className
};

function StoryverseLevelPanel$MaxLevelBarComponent(props) {
  return React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.LevelPanel.make, {
              children: null
            }, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.MaxLevelGuide.make, {
                  children: null
                }, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.Flare.make, {}), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.YellowStar.make, {}), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.StartLevelText.make, {
                      children: String(props.fromLevel)
                    }), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.MaxLevelText.make, {})), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.StoryPoints.make, {
                  children: "Story Points: " + props.currentValue.toLocaleString()
                }));
}

var MaxLevelBarComponent = {
  make: StoryverseLevelPanel$MaxLevelBarComponent
};

function StoryverseLevelPanel$DefaultLevelBarComponent(props) {
  var currentValue = props.currentValue;
  var toValue = props.toValue;
  var fromValue = props.fromValue;
  var allowedToShowLevelBar = toValue >= fromValue && currentValue >= fromValue && currentValue <= toValue;
  if (!allowedToShowLevelBar) {
    return null;
  }
  var range = toValue - fromValue | 0;
  var valueOffset = currentValue - fromValue | 0;
  var percentOne = valueOffset / range;
  var percentValue = percentOne * 100.0;
  var blueStars = percentOne >= 0.75 ? React.createElement(React.Fragment, {}, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.BlueStar.make, {
              index: 0
            }), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.BlueStar.make, {
              index: 1
            }), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.BlueStar.make, {
              index: 2
            })) : (
      percentOne >= 0.5 ? React.createElement(React.Fragment, {}, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.BlueStar.make, {
                  index: 0
                }), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.BlueStar.make, {
                  index: 1
                }), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.QuestionStar.make, {
                  index: 2
                })) : (
          percentOne >= 0.25 ? React.createElement(React.Fragment, {}, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.BlueStar.make, {
                      index: 0
                    }), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.QuestionStar.make, {
                      index: 1
                    }), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.QuestionStar.make, {
                      index: 2
                    })) : React.createElement(React.Fragment, {}, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.QuestionStar.make, {
                      index: 0
                    }), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.QuestionStar.make, {
                      index: 1
                    }), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.QuestionStar.make, {
                      index: 2
                    }))
        )
    );
  return React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.LevelPanel.make, {
              children: null
            }, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.LevelGuide.make, {
                  children: null
                }, React.createElement(DynamicLevelBar$LiteracyplanetClientSxEntry.LevelBarValue.make, {
                      className: className,
                      percentValue: percentValue
                    }), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.Flare.make, {}), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.YellowStar.make, {}), blueStars, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.StartLevelText.make, {
                      children: String(props.fromLevel)
                    }), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.EndLevelText.make, {
                      children: String(props.toLevel)
                    })), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.StoryPoints.make, {
                  children: "Story Points: " + (currentValue.toLocaleString() + (" / " + toValue.toLocaleString()))
                }));
}

var DefaultLevelBarComponent = {
  make: StoryverseLevelPanel$DefaultLevelBarComponent
};

function StoryverseLevelPanel$LevelBarLoadedComponent(props) {
  var currentValue = props.currentValue;
  var fromLevel = props.fromLevel;
  if (props.hasReachedMaxLevel) {
    return React.createElement(StoryverseLevelPanel$MaxLevelBarComponent, {
                fromLevel: fromLevel,
                currentValue: currentValue
              });
  } else {
    return React.createElement(StoryverseLevelPanel$DefaultLevelBarComponent, {
                fromLevel: fromLevel,
                toLevel: props.toLevel,
                fromValue: props.fromValue,
                toValue: props.toValue,
                currentValue: currentValue
              });
  }
}

var LevelBarLoadedComponent = {
  make: StoryverseLevelPanel$LevelBarLoadedComponent
};

function StoryverseLevelPanel$LevelBarLoadingComponent(props) {
  return React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.LevelPanel.make, {
              children: React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.LoadingLevelText.make, {})
            });
}

var LevelBarLoadingComponent = {
  make: StoryverseLevelPanel$LevelBarLoadingComponent
};

function StoryverseLevelPanel$LevelBarContainer(props) {
  var navigation = props.navigation;
  if (typeof navigation !== "object") {
    return React.createElement(StoryverseLevelPanel$LevelBarLoadingComponent, {});
  }
  var match = navigation._0.spBar;
  return React.createElement(StoryverseLevelPanel$LevelBarLoadedComponent, {
              hasReachedMaxLevel: match.hasReachedMaxLevel,
              fromLevel: match.fromLevel,
              toLevel: match.toLevel,
              fromValue: match.fromValue,
              toValue: match.toValue,
              currentValue: match.currentValue
            });
}

var LevelBarContainer = {
  make: StoryverseLevelPanel$LevelBarContainer
};

var r$1 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.width,
        488
      ],
      tl: /* [] */0
    });

var cols = Theme$LiteracyplanetClientFlags.resizeGridCols({
      hd: {
        NAME: "css",
        VAL: {
          NAME: "fr",
          VAL: 1.0
        }
      },
      tl: /* [] */0
    });

var css$1 = Curry._1(Css.style, {
      hd: Css.display("grid"),
      tl: {
        hd: Css.justifyContent(Css.center),
        tl: {
          hd: Css.justifyItems(Css.center),
          tl: {
            hd: Css.alignContent(Css.center),
            tl: {
              hd: Css.alignItems(Css.center),
              tl: /* [] */0
            }
          }
        }
      }
    });

var className$1 = Curry._1(Css.merge, {
      hd: r$1,
      tl: {
        hd: cols,
        tl: {
          hd: css$1,
          tl: {
            hd: "IconPanel",
            tl: /* [] */0
          }
        }
      }
    });

var IconCenterPanelStyle = {
  r: r$1,
  cols: cols,
  css: css$1,
  className: className$1
};

function StoryverseLevelPanel$IconCenterPanel(props) {
  return React.createElement("div", {
              className: className$1
            }, props.children);
}

var IconCenterPanel = {
  make: StoryverseLevelPanel$IconCenterPanel
};

var r$2 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.gridColumnGap,
        12
      ],
      tl: /* [] */0
    });

var cols$1 = Theme$LiteracyplanetClientFlags.resizeGridCols({
      hd: {
        NAME: "css",
        VAL: {
          NAME: "fr",
          VAL: 1.0
        }
      },
      tl: {
        hd: {
          NAME: "css",
          VAL: {
            NAME: "fr",
            VAL: 1.0
          }
        },
        tl: {
          hd: {
            NAME: "css",
            VAL: {
              NAME: "fr",
              VAL: 1.0
            }
          },
          tl: /* [] */0
        }
      }
    });

var css$2 = Curry._1(Css.style, {
      hd: Css.display("grid"),
      tl: {
        hd: Css.justifyContent(Css.center),
        tl: {
          hd: Css.justifyItems(Css.center),
          tl: {
            hd: Css.alignContent(Css.center),
            tl: {
              hd: Css.alignItems(Css.center),
              tl: /* [] */0
            }
          }
        }
      }
    });

var className$2 = Curry._1(Css.merge, {
      hd: r$2,
      tl: {
        hd: cols$1,
        tl: {
          hd: css$2,
          tl: {
            hd: "IconPanel",
            tl: /* [] */0
          }
        }
      }
    });

var IconPanelStyle = {
  r: r$2,
  cols: cols$1,
  css: css$2,
  className: className$2
};

function StoryverseLevelPanel$IconPanel(props) {
  return React.createElement("div", {
              className: className$2
            }, props.children);
}

var IconPanel = {
  make: StoryverseLevelPanel$IconPanel
};

var r$3 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.width,
        564
      ],
      tl: {
        hd: [
          Css.height,
          587
        ],
        tl: {
          hd: [
            Css.top,
            56
          ],
          tl: /* [] */0
        }
      }
    });

var rows = Theme$LiteracyplanetClientFlags.resizeGridRows({
      hd: {
        NAME: "ratio",
        VAL: 50
      },
      tl: {
        hd: {
          NAME: "ratio",
          VAL: 158
        },
        tl: {
          hd: {
            NAME: "ratio",
            VAL: 100
          },
          tl: {
            hd: {
              NAME: "ratio",
              VAL: 164
            },
            tl: {
              hd: {
                NAME: "ratio",
                VAL: 80
              },
              tl: /* [] */0
            }
          }
        }
      }
    });

var css$3 = Curry._1(Css.style, {
      hd: Css.zIndex(10),
      tl: {
        hd: Css.position(Css.absolute),
        tl: {
          hd: Css.display("grid"),
          tl: {
            hd: Css.justifyContent(Css.center),
            tl: {
              hd: Css.alignItems(Css.center),
              tl: {
                hd: Css.justifyItems(Css.center),
                tl: {
                  hd: Css.background(Css.url(dropDown)),
                  tl: {
                    hd: Css.backgroundSize("contain"),
                    tl: {
                      hd: Css.backgroundRepeat("noRepeat"),
                      tl: {
                        hd: Css.backgroundPosition(Css.center),
                        tl: {
                          hd: Css.userSelect(Css.none),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var className$3 = Curry._1(Css.merge, {
      hd: r$3,
      tl: {
        hd: rows,
        tl: {
          hd: css$3,
          tl: {
            hd: "BodyPanel",
            tl: /* [] */0
          }
        }
      }
    });

var BodyPanelStyle = {
  r: r$3,
  rows: rows,
  css: css$3,
  className: className$3
};

function StoryverseLevelPanel$BodyPanel(props) {
  return React.createElement("div", {
              className: className$3
            }, props.children);
}

var BodyPanel = {
  make: StoryverseLevelPanel$BodyPanel
};

var r$4 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.width,
        112
      ],
      tl: {
        hd: [
          Css.height,
          96
        ],
        tl: /* [] */0
      }
    });

var css$4 = Curry._1(Css.style, {
      hd: Css.zIndex(100),
      tl: {
        hd: Css.display("grid"),
        tl: {
          hd: Css.justifyContent(Css.center),
          tl: {
            hd: Css.alignItems(Css.center),
            tl: {
              hd: Css.backgroundColor(Css.red),
              tl: /* [] */0
            }
          }
        }
      }
    });

var className$4 = Curry._1(Css.merge, {
      hd: r$4,
      tl: {
        hd: css$4,
        tl: /* [] */0
      }
    });

var ItemIconWrapperStyle = {
  r: r$4,
  css: css$4,
  className: className$4
};

function StoryverseLevelPanel$ItemIconWrapper(props) {
  return React.createElement("div", {
              className: className$4
            }, props.children);
}

var ItemIconWrapper = {
  make: StoryverseLevelPanel$ItemIconWrapper
};

var r$5 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.width,
        112
      ],
      tl: /* [] */0
    });

var css$5 = Curry._1(Css.style, {
      hd: Css.display("grid"),
      tl: {
        hd: Css.justifyContent(Css.center),
        tl: {
          hd: Css.alignItems(Css.center),
          tl: {
            hd: Css.backgroundSize("contain"),
            tl: {
              hd: Css.backgroundRepeat("noRepeat"),
              tl: {
                hd: Css.backgroundPosition(Css.center),
                tl: {
                  hd: Css.gridColumnStart(1),
                  tl: {
                    hd: Css.gridColumnEnd(2),
                    tl: {
                      hd: Css.gridRowStart(1),
                      tl: {
                        hd: Css.gridRowEnd(2),
                        tl: {
                          hd: Css.height(Css.pct(100.0)),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var className$5 = Curry._1(Css.merge, {
      hd: r$5,
      tl: {
        hd: css$5,
        tl: {
          hd: "ItemIcon",
          tl: /* [] */0
        }
      }
    });

var ItemIconStyle = {
  r: r$5,
  css: css$5,
  className: className$5
};

function StoryverseLevelPanel$ItemIcon(props) {
  var __locked = props.locked;
  var icon = props.icon;
  var locked = __locked !== undefined ? __locked : false;
  var className$6 = locked ? Curry._1(Css.merge, {
          hd: Curry._1(Css.style, {
                hd: Css.background(Css.url(icon)),
                tl: {
                  hd: Css.filter({
                        hd: {
                          NAME: "grayscale",
                          VAL: 90.0
                        },
                        tl: /* [] */0
                      }),
                  tl: /* [] */0
                }
              }),
          tl: {
            hd: className$5,
            tl: /* [] */0
          }
        }) : Curry._1(Css.merge, {
          hd: Curry._1(Css.style, {
                hd: Css.background(Css.url(icon)),
                tl: /* [] */0
              }),
          tl: {
            hd: className$5,
            tl: /* [] */0
          }
        });
  return React.createElement("div", {
              className: className$6
            }, props.children);
}

var ItemIcon = {
  make: StoryverseLevelPanel$ItemIcon
};

var r$6 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.width,
        51
      ],
      tl: {
        hd: [
          Css.height,
          53
        ],
        tl: {
          hd: [
            Css.top,
            400
          ],
          tl: {
            hd: [
              Css.left,
              400
            ],
            tl: /* [] */0
          }
        }
      }
    });

var css$6 = Curry._1(Css.style, {
      hd: Css.background(Css.url(checkpoint)),
      tl: {
        hd: Css.backgroundSize(Css.cover),
        tl: {
          hd: Css.display(Css.grid),
          tl: /* [] */0
        }
      }
    });

var className$6 = Curry._1(Css.merge, {
      hd: css$6,
      tl: {
        hd: r$6,
        tl: {
          hd: "Checkpoint",
          tl: /* [] */0
        }
      }
    });

var Checkpoint = {
  r: r$6,
  css: css$6,
  className: className$6
};

var r$7 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.width,
        112
      ],
      tl: {
        hd: [
          Css.height,
          99
        ],
        tl: /* [] */0
      }
    });

var css$7 = Curry._1(Css.style, /* [] */0);

var className$7 = Curry._1(Css.merge, {
      hd: r$7,
      tl: {
        hd: css$7,
        tl: /* [] */0
      }
    });

var ResizeOnHoverStyle = {
  r: r$7,
  css: css$7,
  className: className$7
};

function StoryverseLevelPanel$ResizeOnHover(props) {
  return React.createElement("div", {
              className: className$7
            }, props.children);
}

var ResizeOnHover = {
  make: StoryverseLevelPanel$ResizeOnHover
};

var css$8 = Curry._1(Css.style, {
      hd: Css.display(Css.grid),
      tl: {
        hd: Css.backgroundRepeat(Css.noRepeat),
        tl: {
          hd: Css.backgroundPosition(Css.center),
          tl: {
            hd: Css.backgroundSize(Css.contain),
            tl: {
              hd: Css.height(Css.pct(100.0)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var className$8 = Curry._1(Css.merge, {
      hd: css$8,
      tl: /* [] */0
    });

var IconStyle = {
  css: css$8,
  className: className$8
};

function StoryverseLevelPanel$Icon(props) {
  var __locked = props.locked;
  var icon = props.icon;
  var locked = __locked !== undefined ? __locked : false;
  var className$9 = locked ? Curry._1(Css.merge, {
          hd: Curry._1(Css.style, {
                hd: Css.backgroundImage(Css.url(icon)),
                tl: {
                  hd: Css.filter({
                        hd: {
                          NAME: "grayscale",
                          VAL: 90.0
                        },
                        tl: /* [] */0
                      }),
                  tl: /* [] */0
                }
              }),
          tl: {
            hd: className$8,
            tl: /* [] */0
          }
        }) : Curry._1(Css.merge, {
          hd: Curry._1(Css.style, {
                hd: Css.backgroundImage(Css.url(icon)),
                tl: /* [] */0
              }),
          tl: {
            hd: className$8,
            tl: /* [] */0
          }
        });
  return React.createElement("div", {
              className: className$9
            }, props.children);
}

var Icon = {
  make: StoryverseLevelPanel$Icon
};

var cssHover = Theme$LiteracyplanetClientFlags.dimensionsHover(className$7, 120, 106);

var r$8 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.width,
        120
      ],
      tl: {
        hd: [
          Css.height,
          138
        ],
        tl: /* [] */0
      }
    });

var rows$1 = Theme$LiteracyplanetClientFlags.resizeGridRows({
      hd: {
        NAME: "ratio",
        VAL: 103
      },
      tl: {
        hd: {
          NAME: "ratio",
          VAL: 20
        },
        tl: /* [] */0
      }
    });

var css$9 = Curry._1(Css.style, {
      hd: Css.display(Css.grid),
      tl: {
        hd: Css.justifyContent(Css.center),
        tl: {
          hd: Css.justifyItems(Css.center),
          tl: {
            hd: Css.alignContent(Css.center),
            tl: {
              hd: Css.alignItems(Css.center),
              tl: {
                hd: Css.background(Css.url(iconBacking)),
                tl: {
                  hd: Css.backgroundRepeat("noRepeat"),
                  tl: {
                    hd: Css.backgroundPosition("bottom"),
                    tl: {
                      hd: Css.backgroundSize("contain"),
                      tl: {
                        hd: Css.cursor(Css.pointer),
                        tl: {
                          hd: Css.hover({
                                hd: Css.background(Css.url(iconBackingActive)),
                                tl: {
                                  hd: Css.backgroundRepeat("noRepeat"),
                                  tl: {
                                    hd: Css.backgroundPosition("bottom"),
                                    tl: {
                                      hd: Css.backgroundSize("contain"),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }),
                          tl: {
                            hd: Css.active({
                                  hd: Css.background(Css.url(iconBackingActive)),
                                  tl: {
                                    hd: Css.backgroundRepeat("noRepeat"),
                                    tl: {
                                      hd: Css.backgroundPosition("bottom"),
                                      tl: {
                                        hd: Css.backgroundSize("contain"),
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }),
                            tl: {
                              hd: CssUtils$LiteracyplanetClientSxEntry.preloadImages({
                                    hd: iconBackingActive,
                                    tl: /* [] */0
                                  }),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var className$9 = Curry._1(Css.merge, {
      hd: cssHover,
      tl: {
        hd: r$8,
        tl: {
          hd: rows$1,
          tl: {
            hd: css$9,
            tl: /* [] */0
          }
        }
      }
    });

var ItemPanelStyle = {
  cssHover: cssHover,
  r: r$8,
  rows: rows$1,
  css: css$9,
  className: className$9
};

var r$9 = Theme$LiteracyplanetClientFlags.resize({
      hd: [
        Css.width,
        120
      ],
      tl: {
        hd: [
          Css.height,
          138
        ],
        tl: /* [] */0
      }
    });

var rows$2 = Theme$LiteracyplanetClientFlags.resizeGridRows({
      hd: {
        NAME: "ratio",
        VAL: 103
      },
      tl: {
        hd: {
          NAME: "ratio",
          VAL: 20
        },
        tl: /* [] */0
      }
    });

var css$10 = Curry._1(Css.style, {
      hd: Css.display(Css.grid),
      tl: {
        hd: Css.justifyContent(Css.center),
        tl: {
          hd: Css.justifyItems(Css.center),
          tl: {
            hd: Css.alignContent(Css.center),
            tl: {
              hd: Css.alignItems(Css.center),
              tl: {
                hd: Css.background(Css.url(iconBackingLocked)),
                tl: {
                  hd: Css.backgroundRepeat("noRepeat"),
                  tl: {
                    hd: Css.backgroundPosition("bottom"),
                    tl: {
                      hd: Css.backgroundSize("contain"),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var className$10 = Curry._1(Css.merge, {
      hd: r$9,
      tl: {
        hd: rows$2,
        tl: {
          hd: css$10,
          tl: /* [] */0
        }
      }
    });

var ItemPanelLockedStyle = {
  r: r$9,
  rows: rows$2,
  css: css$10,
  className: className$10
};

function StoryverseLevelPanel$ItemPanel(props) {
  var __locked = props.locked;
  var locked = __locked !== undefined ? __locked : false;
  var className$11 = locked ? className$10 : className$9;
  return React.createElement("div", {
              className: className$11,
              onClick: props.onClick
            }, React.createElement(StoryverseLevelPanel$ResizeOnHover, {
                  children: React.createElement(StoryverseLevelPanel$Icon, {
                        children: null,
                        icon: props.icon,
                        locked: locked
                      })
                }), locked ? null : React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.ItemText.make, {
                    text: props.name
                  }));
}

var ItemPanel = {
  make: StoryverseLevelPanel$ItemPanel
};

var css$11 = Curry._1(Css.style, {
      hd: Css.color(Css.red),
      tl: /* [] */0
    });

var className$11 = Curry._1(Css.merge, {
      hd: css$11,
      tl: /* [] */0
    });

var RedStyle = {
  css: css$11,
  className: className$11
};

function StoryverseLevelPanel$Red(props) {
  return React.createElement("div", {
              className: className$11
            }, props.children);
}

var Red = {
  make: StoryverseLevelPanel$Red
};

function StoryverseLevelPanel$SubMenuButtons(props) {
  var closeHeaderPanel = props.closeHeaderPanel;
  var onClickShop = props.onClickShop;
  var onClickArcade = props.onClickArcade;
  var onClickBog = props.onClickBog;
  return React.createElement(StoryverseLevelPanel$IconCenterPanel, {
              children: React.createElement(StoryverseLevelPanel$IconPanel, {
                    children: null
                  }, React.createElement(StoryverseLevelPanel$ItemPanel, {
                        onClick: (function (param) {
                            Curry._1(onClickBog, undefined);
                            Curry._1(closeHeaderPanel, undefined);
                          }),
                        name: "Book of Goings",
                        icon: StoryverseIcons$LiteracyplanetClientSxEntry.bookIcon
                      }), React.createElement(StoryverseLevelPanel$ItemPanel, {
                        onClick: (function (param) {
                            Curry._1(onClickArcade, undefined);
                            Curry._1(closeHeaderPanel, undefined);
                          }),
                        name: "Arcade",
                        icon: StoryverseIcons$LiteracyplanetClientSxEntry.arcadeIcon,
                        locked: props.lockArcade
                      }), React.createElement(StoryverseLevelPanel$ItemPanel, {
                        onClick: (function (param) {
                            Curry._1(onClickShop, undefined);
                            Curry._1(closeHeaderPanel, undefined);
                          }),
                        name: "Shop",
                        icon: StoryverseIcons$LiteracyplanetClientSxEntry.shopIcon,
                        locked: props.lockShop
                      }))
            });
}

var SubMenuButtons = {
  make: StoryverseLevelPanel$SubMenuButtons
};

function StoryverseLevelPanel(props) {
  var closeHeaderPanel = props.closeHeaderPanel;
  var navigation = props.navigation;
  return React.createElement(StoryverseLevelPanel$BodyPanel, {
              children: null
            }, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.Spacer.make, {}), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.LevelPanelContainer.make, {
                  children: null
                }, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.LevelPanelBanner.make, {
                      children: React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.BannerText.make, {
                            children: "Storyverse Level"
                          })
                    }), React.createElement(StoryverseLevelPanel$LevelBarContainer, {
                      navigation: navigation
                    })), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.ProfilePanel.make, {
                  children: React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.ProfileInnerPanel.make, {
                        children: null
                      }, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.ProfileNamePanel.make, {
                            children: null
                          }, React.createElement(StoryverseIcons$LiteracyplanetClientSxEntry.ProfileIcon.make, {}), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.ProfileText.make, {
                                userName: props.userName
                              }), React.createElement(StoryverseIcons$LiteracyplanetClientSxEntry.LocationIcon.make, {}), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.LocationText.make, {
                                navigation: navigation
                              })), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.ProfileGemsPanel.make, {
                            children: null
                          }, React.createElement(StoryverseIcons$LiteracyplanetClientSxEntry.GemIcon.make, {}), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.GemCountText.make, {
                                navigation: navigation
                              })))
                }), React.createElement(StoryverseLevelPanel$SubMenuButtons, {
                  onClickBog: props.onClickBog,
                  onClickCollections: props.onClickCollections,
                  lockArcade: props.lockArcade,
                  onClickArcade: props.onClickArcade,
                  lockShop: props.lockShop,
                  onClickShop: props.onClickShop,
                  closeHeaderPanel: closeHeaderPanel
                }), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.CloseButton.make, {
                  children: null,
                  onClick: (function (param) {
                      Curry._1(closeHeaderPanel, undefined);
                    })
                }, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.Spacer.make, {}), React.createElement(StoryverseIcons$LiteracyplanetClientSxEntry.CloseIcon.make, {}), "Close"));
}

var ratio = Theme$LiteracyplanetClientFlags.resize;

var resizeGridCols = Theme$LiteracyplanetClientFlags.resizeGridCols;

var resizeGridRows = Theme$LiteracyplanetClientFlags.resizeGridRows;

var maximumWidth = Theme$LiteracyplanetClientFlags.maximumWidth;

var make = StoryverseLevelPanel;

export {
  brownColor ,
  whiteColor ,
  bottomBlueColor ,
  topBlueColor ,
  blueColor ,
  offWhiteColor ,
  lightOffWhiteColor ,
  ratio ,
  resizeGridCols ,
  resizeGridRows ,
  maximumWidth ,
  checkpoint ,
  dropDown ,
  iconBacking ,
  iconBackingActive ,
  iconBackingLocked ,
  DynamicLevelBarStyle ,
  MaxLevelBarComponent ,
  DefaultLevelBarComponent ,
  LevelBarLoadedComponent ,
  LevelBarLoadingComponent ,
  LevelBarContainer ,
  IconCenterPanelStyle ,
  IconCenterPanel ,
  IconPanelStyle ,
  IconPanel ,
  BodyPanelStyle ,
  BodyPanel ,
  ItemIconWrapperStyle ,
  ItemIconWrapper ,
  ItemIconStyle ,
  ItemIcon ,
  Checkpoint ,
  ResizeOnHoverStyle ,
  ResizeOnHover ,
  IconStyle ,
  Icon ,
  ItemPanelStyle ,
  ItemPanelLockedStyle ,
  ItemPanel ,
  RedStyle ,
  Red ,
  SubMenuButtons ,
  make ,
}
/* brownColor Not a pure module */
